import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input } from '@angular/core';

@Component({
  selector: 'rcp-loading-indicator',
  styleUrls: ['./loading-indicator.component.scss'],
  host: {
    '[class.is-shown]': 'while',
    '(transitionstart)': 'onTransitionStart($event)',
    '(transitionend)': 'onTransitionEnd($event)',
  },
  template: `
    <div class="loading-container" [class.shown]="shown" [class.mode-line]="mode === 'line'">
      <!-- default mode -->
      @if (mode === 'default' || !progress) {
        <div class="bounce-animation">
          <div class="line"></div>
        </div>
      }

      <!-- mode line progress -->
      @if (mode === 'line' && !!progress) {
        <div class="line-progress" [style.width]="progress * 100 + '%'"></div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LoadingIndicatorComponent {
  private changeDetector = inject(ChangeDetectorRef);

  @Input() while = true;
  @Input() mode: 'default' | 'line' = 'default';

  // the progress to show if mode is line (0-1)
  @Input() progress: number;

  shown: boolean;

  onTransitionStart(event: TransitionEvent) {
    if (event.propertyName === 'opacity') {
      this.shown = true;
      this.changeDetector.detectChanges();
    }
  }

  onTransitionEnd(event: TransitionEvent) {
    if (event.propertyName === 'opacity' && !this.while) {
      this.shown = false;
      this.changeDetector.detectChanges();
    }
  }
}
